// 其它單元也要使用，搬移到all-main.js
// /* ---------------------------------------- [START] 輸入 Filter */
// (function (window, document) {
// 	/* 只能輸入數字 */
// 	// setInputFilter(document.querySelectorAll('.js-input-num'), function (value) {
// 	// 	return /^\d*$/.test(value);
// 	// });

// 	/* 只能輸入數字 + 英文 */
// 	// setInputFilter(document.querySelectorAll('.js-input-num-a-z'), function (value) {
// 	// 	return /^[a-zA-Z0-9]*$/.test(value);
// 	// });

// 	/* 只能輸入電話相關 */
// 	setInputFilter(document.querySelectorAll('.js-input-tel'), function (value) {
// 		return /^[\d-+\s()#]*$/.test(value);
// 	});
// })(window, document);

// /* Ref (Richart): https://richart.tw/TSDIB_RichartWeb/static/revamp/js/InputFilter.js
//  * Restricts input for the given textbox to the given inputFilter.
//  */
// function setInputFilter(x, inputFilter) {
// 	if (x.length > 0) {
// 		['focus', 'input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(
// 			function (event) {
// 				for (var i = 0; i < x.length; i++) {
// 					x[i].addEventListener(event, function () {
// 						if (inputFilter(this.value)) {
// 							this.oldValue = this.value;
// 							this.oldSelectionStart = this.selectionStart;
// 							this.oldSelectionEnd = this.selectionEnd;
// 						} else if (this.hasOwnProperty('oldValue')) {
// 							this.value = this.oldValue;
// 							this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
// 						} else {
// 							this.value = '';
// 						}
// 					});
// 				}
// 			}
// 		);
// 	}
// }
// /* ---------------------------------------- [END] 輸入 Filter */

(function (window, document) {
	/* ---------------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	const body = document.body || document.querySelector('body');
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	function scrollHandler() {
		ws = getScrollTop();
	}
	window.addEventListener('load', getWinSet);
	window.addEventListener('scroll', scrollHandler);
	window.addEventListener('resize', throttle(getWinSet, 50, 100));
	// ----------------------------
	// 判斷 裝置
	// iOS
	var ua = navigator.userAgent;
	var isiOS = ua.toLowerCase().match(/(iphone|ipod|ipad)/);
	/* ---------------------------------------- [END] Windows Setting */

	/* ---------------------------------------- [START] Match Height */
	const titleEls = $('.js-match-title').find('.form__group-title');
	const calcHeightThrottle = throttle(calcHeight, 50, 100);
	function calcHeight() {
		let max = 0;
		titleEls.each((index, el) => {
			$(el).height('');
			if ( max < $(el).innerHeight()) {
				max = $(el).innerHeight();
			}
		});

		titleEls.height(max);
	}
	const jobBreakpoint = window.matchMedia('(min-width: 1024px)');
	const jobBreakpointChecker = function() {
		if (jobBreakpoint.matches) {
			// Medium + Large
			calcHeight();
			window.addEventListener('resize', calcHeightThrottle);
		} else {
			// Small
			titleEls.height('');
			window.removeEventListener('resize', calcHeightThrottle);
		}
	}
	window.addEventListener('load', function() {
		if (titleEls.length) {
			jobBreakpointChecker();
			jobBreakpoint.addListener(jobBreakpointChecker);
		}
	});
	/* ---------------------------------------- [END] Match Height */

	/* ---------------------------------------- [START] Select2 Tool */
	// 尋找對應的關鍵字
	// Ref: https://stackoverflow.com/a/58218967/11240898
	function matchCustom(params, data) {
		// If there are no search terms, return all of the data
		if ($.trim(params.term) === '') {
			return data;
		}

		// Do not display the item if there is no 'text' property
		if (typeof data.text === 'undefined' || data.id === 'null') {
			return null;
		}

		// `params.term` should be the term that is used for searching
		// `data.text` is the text that is displayed for the data object
		if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
			return data;
		}

		// custom search using lookup data
		// 尋找對應的關鍵字
		if (
			data.element.dataset.keywords &&
			data.element.dataset.keywords.toUpperCase().indexOf(params.term.toUpperCase()) > -1
		) {
			return data;
		}

		// Return `null` if the term should not be displayed
		return null;
	}

	// 篩選首字符合
	// function matchStart(params, data) {
	// 	params.term = params.term || '';
	// 	if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) === 0) {
	// 		return data;
	// 	}
	// 	return false;
	// }

	const lang = document.documentElement.getAttribute('lang');
	const select2Lang = {
		es: 'es', // 西班牙
		de: 'de', // 德文
		fr: 'fr', // 法文
		it: 'it', // 義大利文
		nl: 'nl', // 義大利文
		'zh-Hant-TW': 'zh-TW', // 義大利文
		'zh': 'zh-TW', // 義大利文
	}

	function select2LangGet() {
		return select2Lang[lang] || 'en';
	}

	const select2LangDefined = select2LangGet();

	// SIT 100 - 110 - F_6.1. 聯絡我們 - 修正 iOS 點擊 Select2 相關產生的欄位產生的 Bug
	// 因為結構關係，導致<label>會有兩個欄位，一個<select>（原本的下拉選單）、一個輸入框<input>（生成的）
	// 在iOS系統會導致先出現原生介面的Bug
	function select2AddId($this, index) {
		const parent = $this.parents('label');
		const input = parent.find('input');
		const id = `select-country-${index}`;

		input.attr('id', id);
		// SIT208 - 2022/03/08 發現: 加入驗證後會出錯（當欄位錯誤，整個欄位都會消失），label 不能加 for <select> 或 <input>
		// parent.attr('for', id);
		if (isiOS) {
			parent.attr('for', 'select-country-label'); // 加入沒有意義的項目
		}
	}
	/* ---------------------------------------- [END] Select2 Tool */

	/* ---------------------------------------- [START] Select Country (Select2) */
	function buildSelectCountry() {
		$('.js-select-country').each(function (index, item) {
			var $this = $(item);
			var searchInput;

			var mySelect = $this
				.select2({
					matcher: matchCustom,
					language: select2LangDefined,
					placeholder: $this.data('placeholder'),
					allowClear: true,
					width: '100%',
					dropdownParent: $this.parent(),
					multiple: true, // 將多選強制設置為單選樣式
					// maximumSelectionLength: 1 // 將多選強制設置為單選樣式，但有option空值會產生問題(select require 一定要有空值選項)
				})
				.on('select2:init', function (e) {
					// Init Event
					$this.removeAttr('multiple'); // Remove Multiple
					if (!$this.val()) {
						$this.parent().find('.select2-selection__clear').addClass('hide');
					}

					select2AddId($this, index);
				})
				.on('select2:select', function (e) {
					// 使用單選但又不要下拉呈現
					// Ref: https://stackoverflow.com/a/32575136/11240898
					$this.val([]);
					$this.val([e.params.data.id]).trigger('change');
					$(':focus').blur();
				})
				.on('change', function (e) {
					// 隱藏 Clear All
					// 選擇項目時，會 trigger 兩次 change ，原因不明
					if (!$this.val()) {
						$this.parent().find('.select2-selection__clear').addClass('hide');
					} else {
						$this.parent().find('.select2-selection__clear').removeClass('hide');
					}
				})
				.on('select2:unselect', function (e) {
					// 多選直接按 ←Backspace 時，會出現原項目文字編輯，非整個刪除
					// ↓達成整個刪除
					$this.val(null);
					setTimeout(() => {
						searchInput.val('');
						$this.trigger('change');
						searchInput.trigger('input'); // 重刷 Search
					}, 1);
				})
				.on('select2:clear', function () {
					setTimeout(function () {
						$this.parent().find('input').focus();
					}, 20);
				});

			// Select El
			// Trigger Init, Ref: https://github.com/select2/select2/issues/2572#issuecomment-166941793
			$this.trigger('select2:init');

			$this.on('focus', function () {
				$this.select2('open');
			});

			// ---

			// Input El
			searchInput = $this.parent().find('input');

			// Chrome 會忽略設置 off 的 autocomplete，改其它寫法
			// https://github.com/select2/select2/issues/3313#issuecomment-98642015
			searchInput.attr('autocomplete', 'xxxxxxxxxxx');

			// 更改Type
			searchInput.attr('type', 'text');
		});
	}

	window.addEventListener('load', buildSelectCountry);
	/* ---------------------------------------- [START] Select Country (Select2) */

	/* ---------------------------------------- [START] Select Product (Select2) */
	const selectPdEl = $('.js-select-pd');
	let selectPDBuilded = false;
	function buildSelectPd() {
		// 避免多次生成
		if (selectPDBuilded) {
			return false
		}
		selectPDBuilded = true;

		// let searchInput;

		/* ※Select2 官方文件有說明，如果使用「multiple」就不要使用「空值」物件（For multi-selects, you must not have an empty element (Ref: https://select2.org/placeholders)）
		 * 但如果一開始不要有預設選項，要顯示「placeholder」，得要使用「空值」物件，導致形成衝突。
		 * （Multiple類型如果進行篩選，選擇第一次，空值會被篩選進去，如此發問：https://stackoverflow.com/questions/49943362/select2-multi-select-blank-option-always-selected）
		 * 解法A
		 *  - 第一個空值項目帶入「偽空值」（有值，但卻不會輸出的值），如：null
		 *  - 生成 select2() 後增加： $selectEl.val(null).trigger("change");
		 *  - 缺點：
		 *   - 因為實際上有值會被篩選出來，所以要在 matcher 增加排除該項目的寫法
		 *   - 如果不設定 minimumInputLength >= 1 的值，可能會出現Bug（因為一開始沒有排除）
		 * 
		 * 解法B
		 *  - 移除空值選項，將 select先增加 multiple="" 屬性
		 *  - 缺點：
		 *    - 一開始樣式未生成會看到預設的多選樣式，造成畫面跳動。（部分人不接受）
		 *
		 * 目前使用解法A
		 */

		selectPdEl.each(function(index, item) {
			var $this = $(this);
			var searchInput;

			// 因為 <select> 設置 require 一定要有空值選項（value=''）
			// 但會與 select2 套件產生衝突（原因如上方註解）
			// 所以強制更改 value 值，改成 <option value='null'> 方式進行
			if ($this.data('max') === 1 && $this.find('option[value=""]')) {
				$this.find('option[value=""]').val('null');
			}

			// 建立客製化語言資料
			const language = {}

			if ($this.data('msgMoreChar')) {
				const msg = $this.data('msgMoreChar');
				language.inputTooShort = function() {
					return msg
				}
			}

			if ($this.data('msgNoResults')) {
				const msg = $this.data('msgNoResults');
				language.noResults = function() {
					return msg
				}
			}

			var mySelect = $this
				.select2({
					matcher: matchCustom,
					language: select2LangDefined,
					placeholder: $this.data('placeholder'),
					allowClear: true,
					width: '100%',
					dropdownParent: $this.parent(),
					minimumInputLength: 1, // 至少輸入幾個字
					minimumResultsForSearch: -1,
					multiple: true,
					maximumSelectionLength: $this.data('max') || 100,
					templateResult: formatRepo,
					templateSelection: formatRepoSelection,
					language: language
				})
				.on('select2:init', function() {
					select2AddId($this, 1);
				})
				.on('select2:clear', function () {
					setTimeout(() => {
						$this.parent().find('input').focus();
					}, 10);
				})
				.on('focus', function () {
					$this.select2('open');
				});

			// Select El
			// Trigger Init, Ref: https://github.com/select2/select2/issues/2572#issuecomment-166941793
			$this.trigger('select2:init');

			// set the value to null or empty string '', then trigger (change) event
			$this.val(null).trigger("change");

			// ---

			// Input El
			searchInput = $this.parent().find('input');

			// Chrome 會忽略設置 off 的 autocomplete，改其它寫法
			// https://github.com/select2/select2/issues/3313#issuecomment-98642015
			searchInput.attr('autocomplete', 'xxxxxxxxxxx');

			// 更改Type
			searchInput.attr('type', 'text');
		});

		function formatRepo (repo) {
			if (repo.loading) {
				return repo.text;
			}

			const pdDesc = repo.element.dataset.desc;

			var $container = $(
				"<div class='select-pd-option'>" +
					"<div class='select-pd-option__img-wrapper'>" +
						"<div class='select-pd-option__img-box object-fit'><img src='" + repo.element.dataset.img + "' /></div>" + // 產品圖片
					"</div>" +
					"<div class='select-pd-option__text-wrapper'>" +
						"<div class='select-pd-option__text-box'>" +
							"<div class='select-pd-option__title'>" + repo.text + "</div>" + // 產品 Modal Name
							(pdDesc !== '' ? "<div class='select-pd-option__desc'>" + pdDesc + "</div>" : '') + // 產品敘述
						"</div>" +
					"</div>" +
				"</div>"
			);

			return $container;
		}

		function formatRepoSelection (repo) {
			return repo.full_name || repo.text;
		}
	}

	window.buildSelectPd = buildSelectPd;

	window.addEventListener('load', function() {
		if (selectPdEl.data('init') !== false) {
			buildSelectPd();
		}
	});
	/* ---------------------------------------- [END] Select Product (Select2) */
})(window, document);

/* ---------------------------------------- [START] Date Picker */
/* 相關事項
 * 1. 使用: flatpickr (https://flatpickr.js.org/)
 * 2. Mobile 使用原生 (flatpickr 本身就如此寫法)
 */
(function(window, document) {
	let pickDateEls = null;

	// 語言讀取對應（檔案、l10n使用名稱）
	// key 值對照 html 的 lang 值
	const l10nData = {
		// Global: 國際英文、繁體中文
		// Europe: 英式英文、歐洲西班牙文、德文、法文、義大利文、荷蘭文
		// USA: 美式英文、拉丁美洲西班牙文
		// Taiwan: 國際英文、繁體中文
		// 英文: 英文不用換
		es: 'es', // 西班牙
		de: 'de', // 德文
		fr: 'fr', // 法文
		it: 'it', // 義大利文
		// 繁體中文
		'zh-Hant-TW': {
			file: 'zh-tw',
			property: 'zh_tw' // 因為繁體中文的檔案名稱跟語言名稱不一樣
		}
	}

	// Init: 為了讀取語言項目
	function pickDateInit() {
		const lang = document.documentElement.getAttribute('lang');
		if (l10nData[lang]) {
			const currentLang = l10nData[lang];
			const fileName = typeof currentLang === 'string' ? currentLang : currentLang.file;
			const propertyName = typeof currentLang === 'string' ? currentLang : currentLang.property;

			// 設定語言項目
			loadScript(`${currentScriptPath('js/contact.min.js')}js/vendor/flatpickr/l10n/${fileName}.js`, function() {
				flatpickr.localize(flatpickr.l10ns[propertyName]);
	
				pickDateBuild();
			});

		} else {
			pickDateBuild();
		}
	}

	function pickDateBuild() {
		pickDateEls.forEach((item) => {
			// 因為 flatpickr 的格式跟一般普遍不太一樣，要處理
			let format = item.getAttribute('data-format') || 'DD.MM.YYYY';
			format = format.replace(/YYYY/g, 'Y');
			format = format.replace(/MM/g, 'm');
			format = format.replace(/DD/g, 'd');
	
			const minDate = item.dataset['minDate'] || null;
			
			// Build Picker
			const calendar = flatpickr(item, {
				dateFormat: format,
				minDate: minDate,
				onReady: function() {
					item.flatpickrOpt = this;
					item.dispatchEvent(new CustomEvent('ready'));
				}
			});
		});
	}

	window.addEventListener('load', function() {
		pickDateEls = document.querySelectorAll('.js-pick-date');
		if (pickDateEls.length) {
			
			// data-placeholder 轉換成 placeholder
			// 因為 input(type="date") 不接受 placeholder
			pickDateEls.forEach((item) => {
				if (item.dataset['placeholder']) {
					item.setAttribute('placeholder', item.dataset['placeholder']);
					item.removeAttribute('data-placeholder');
				}
			});

			pickDateInit();
		}
	});

	// =================================================

	// 用 JS 讀取
	function loadScript(path, callback) {
		var script = document.createElement('script');
		script.onload = function () {
			if (callback && typeof callback === 'function') {
				callback();
			}
		};
		script.src = path;

		document.head.appendChild(script); //or something of the likes
	}
})(window, document);
/* ---------------------------------------- [END] Date Picker */



/* ---------------------------------------- [START] Support Warranty */
(function(window, document) {
	//  [?] Icon提示
	$('.form__group-title__button-icon[data-toggle]')
		.on('focus', function() {
			// Focus => 開啟提示
			$('#' + $(this).attr('data-toggle')).foundation('open');
		})
		.on('focusout', function() {
			// Focusout => 關閉提示
			$('#' + $(this).attr('data-toggle')).foundation('close');
		});
})(window, document);
/* ---------------------------------------- [END] Support Warranty */
